<template>
    <div>
        <label :for="id" class="text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
            <slot v-if="headline"></slot>
        </label>
        <div class="bg-white flex items-center justify-between border-gray-200"
             :id="id"
        >
            <div class="flex-1 flex items-center justify-between">
                <div>
                    <div class="relative z-0 inline-flex flex-wrap">
                        <a v-for="(v, i) in values" @click="toggle(v)"
                           class="cursor-pointer mr-2 mb-2 relative inline-flex items-center px-4 py-2 whitespace-nowrap rounded-lg border-2 bg-white text-sm font-medium hover:bg-gray-50"
                           :class="{
                            'border-indigo-500': isActive(v),
                            'bg-red-50 border-red-200 text-gray-500': !isAvailable(i),
                            'text-gray-700 border-gray-300': isAvailable(i),
                        }">
                            {{ text[i] }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <p class="mt-2 text-sm text-gray-500" v-if="hasHelperSlot">
            <slot name="helper"></slot>
        </p>
    </div>
</template>

<script>
import uniqueId from "lodash/uniqueId";

export default {
    name: "MultiSelectSmall",

    props: {
        value: {
            type: Array,
        },
        values: {
            type: Array,
        },
        text: {
            type: Array,
        },
        quantity: {
            type: Array,
            default: () => ([]),
        },
        disabled: {
            type: Array,
            default: () => ([]),
        },
        headline: {
            default: true,
        },
    },

    data: () => ({
        id: uniqueId(),
    }),

    computed: {
        local: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        hasHelperSlot() {
            return !!this.$slots['helper'];
        },
    },

    methods: {
        isActive(value) {
            return this.local.indexOf(value) !== -1;
        },
        isAvailable(index) {
            return this.hasQuantity(index) && !this.isDisabled(index);
        },
        hasQuantity(index) {
            if (this.quantity[index] === undefined) {
                return true;
            }
            return this.quantity[index] > 0;
        },
        isDisabled(index) {
            if (this.disabled[index] === undefined) {
                return false;
            }

            return this.disabled[index];
        },
        toggle(value) {
            const index = this.local.indexOf(value);

            if (!this.isAvailable(this.values.indexOf(value))) {
                return;
            }

            if (index === -1) {
                this.local.push(value);
            } else {
                this.local.splice(index, 1);
            }
        }
    }
}
</script>

<style scoped>

</style>
